// 券宝宝隐私政策。
//
// 2026-09-18 整页重写。此前这里挂的是德国 Satisfyer 的模板：数据控制方写着
// 「EIS GmbH und Triple A Marketing GmbH」，邮箱是 privacymanager@satisfyer.com，
// 法律依据引的是 GDPR。对外公示的数据控制方写成别家公司，用户按那个邮箱
// 行使权利我们根本收不到，也就谈不上在法定时限内回应。
//
// 现在这份是把《商家条款》第 8/11 节和《博主条款》第 9/10/11 节里的隐私内容
// 合并去重，再按系统**实际**在做的事补齐 —— 尤其是第 4 条那张服务商清单，
// 是对着代码里真正调用的服务列的，不是照抄模板。条款跟系统对不上才是真风险。

import React from 'react';
import LegalDoc from '../legal/LegalDoc';
import data from '../legal/privacyData.json';

const LEDE = {
  zh: '这份政策说明我们收集哪些信息、拿它做什么、会给谁、存多久，以及您可以要求我们做什么。适用于普通用户、商家和博主。',
  en: 'This policy explains what we collect, what we use it for, who we share it with, how long we keep it, and what you can ask us to do. It applies to consumers, Merchants and Creators.',
};

export default function PrivacyPolicy() {
  return (
    <LegalDoc
      docKey="privacy"
      titleOf={(l) => data[l].title}
      ledeOf={(l) => LEDE[l]}
      sectionsOf={(l) => data[l].sections}
      updated="2026-09-18"
      footLinks={[
        { href: '#/userProtocol', label: { zh: '服务条款', en: 'Terms of Service' } },
      ]}
    />
  );
}
